import { useState, useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { HistoryGrid, HistoryDetail } from '@/features/history';
import type { HistoryItem } from '@/features/history';
import { useGenerationFormStore } from '@/features/generation';
import { PageLayout } from '@/shared/components';

export function HistoryPage() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [selectedItem, setSelectedItem] = useState<HistoryItem | null>(null);
  const formStore = useGenerationFormStore();

  const handleReuse = useCallback(
    (item: HistoryItem) => {
      formStore.setCheckpoint(item.checkpoint);
      formStore.setPositivePrompt(item.positive_prompt);
      formStore.setNegativePrompt(item.negative_prompt);
      formStore.setWidth(item.width);
      formStore.setHeight(item.height);
      formStore.setSamplerName(item.sampler_name);
      formStore.setScheduler(item.scheduler);
      formStore.setSteps(item.steps);
      formStore.setCfgScale(item.cfg_scale);
      formStore.setSeed(item.seed);
      void navigate('/');
    },
    [formStore, navigate],
  );

  return (
    <PageLayout title={t('history.title')}>
      {selectedItem ? (
        <HistoryDetail
          item={selectedItem}
          onClose={() => setSelectedItem(null)}
          onReuse={handleReuse}
        />
      ) : (
        <HistoryGrid onSelect={setSelectedItem} />
      )}
    </PageLayout>
  );
}
